// extracted by mini-css-extract-plugin
export default {"item":"item_lv16E","numbering":"numbering_MYg9K","iconStyle":"iconStyle_9eYjH","text":"text_GftMT"};